export default __webpack_public_path__ + "static/media/login.e2f3960f.jpg";